'use strict';

var math = require('./math');

var toISOString = Date.prototype.toISOString;
if (!toISOString) {
  toISOString = function() {
    return this.getUTCFullYear()
        + '-' + math.pad(this.getUTCMonth() + 1)
        + '-' + math.pad(this.getUTCDate())
        + 'T' + math.pad(this.getUTCHours())
        + ':' + math.pad(this.getUTCMinutes())
        + ':' + math.pad(this.getUTCSeconds())
        + '.' + String((this.getUTCMilliseconds()/1000).toFixed(3)).slice(2, 5);
        + 'Z';
  };
}

module.exports = {
  toISOString: function(date) {
    return toISOString.call(date);
  },
  toLocalISOString: function(date) {
    var offset = date.getTimezoneOffset();
    date = new Date(date - offset * 60000);
    var isoString = toISOString.call(date);
    var sign = math.sign(-offset);
    var offset = Math.abs(offset)
    return isoString.slice(0, -1) + sign +
        math.pad(Math.floor(offset / 60)) + ':' + math.pad(offset % 60);
  }
};



//////////////////
// WEBPACK FOOTER
// ./lib/date.js
// module id = 12
// module chunks = 1 3